export default "__VITE_ASSET__CrlxFjWN__"